
// Used through the app to provide routes
// to navigate to

// APP ROUTES
export const internalRoutes = {
    // ---- Meta navigation
    authentication: "/authentification",
    // ---- Main navigation
    home: "/",
    games: "/jeux",
    glossary: "/glossaire",
    courses: "/cours-et-exercices",
    knowledges: "/connaissances",
    // ---- Games
    mentalLevelOneGame: "/jeux/calcul-mental/tables-multiplication",
    relativeLevelOneGame: "/jeux/relatifs/addition-relatifs",
    relativeLevelTwoGame: "/jeux/relatifs/soustraire-relatifs",
    // ---- Side navigation
    about: "/a-propos",
    legals: "/mentions-legales",
    privacy: "/confidentialite",
    support: "/soutenir",
    themes: "/programme",
    // ---- Off limit navigation
    previewQuestion: "/preview/question/:id",
    previewExerciser: "/preview/exerciser/:identifier",
}